// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowDown from '../_raw/ui/icon_arrow_down.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowDown);
